export default {
  name: "FooterSection",

  data() {
    return {
      footer_data: {
        brand: {
          initial: "G",
          name: "GovFlow",
          description:
            "Comprehensive B-BBEE programme management and SANAS audit readiness platform.",
          powered_by: "",
        },

        platform: {
          title: "Platform",
          links: [
            { key: "features", label: "Features", href: "#" },
            { key: "pricing", label: "Pricing", href: "#" },
            { key: "integrations", label: "Integrations", href: "#" },
            { key: "security", label: "Security", href: "#" },
          ],
        },

        resources: {
          title: "Resources",
          links: [
            { key: "bee", label: "BEE Codes", href: "#" },
            { key: "verification", label: "Verification Guidelines", href: "#" },
            { key: "faq", label: "FAQs", href: "#" },
            { key: "training", label: "Training", href: "#" },
          ],
        },

        legal: {
          title: "Legal",
          links: [
            { key: "privacy", label: "Privacy Policy", href: "#" },
            { key: "terms", label: "Terms of Service", href: "#" },
            { key: "popia", label: "POPIA Compliance", href: "#" },
          ],
        },

        rights: {
          year: 2026,
          company: "GovFlow",
          text: "All rights reserved.",
          origin: "Made in South Africa",
        },
      },
    };
  },
};
